import { useQuery } from "react-query";

import { fetchDeploymentFinding } from "@api";
import { useOrg } from "@hooks/useOrg";

interface Props {
  id: string;
}
export const useFinding = ({ id }: Props) => {
  const org = useOrg();

  return useQuery(
    ["finding", { org, id }],
    () =>
      fetchDeploymentFinding(org?.id!, id).then((response) => {
        return response;
      }),
    {
      enabled: !!org,
    }
  );
};
